import styled from "styled-components";
import media from "../../../../styles/media";

interface HeaderSearchContainerProps {
  size: 'small' | 'medium' | 'large';
}

const HeaderSearchContainer = styled.div<HeaderSearchContainerProps>`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 1rem;
  position: relative;
  z-index: 1202;

  /* Tamanhos baseados na prop size */
  width: ${(props: HeaderSearchContainerProps) => {
    switch (props.size) {
      case 'large': return '400px';
      case 'medium': return '320px';
      case 'small': return '250px';
      default: return '320px';
    }
  }};

  /* Tamanhos responsivos usando data attributes */
  &[data-size="large"] {
    ${media.lessThan("medium")`
      width: 280px;
    `}
    ${media.lessThan("small")`
      width: 200px;
    `}
  }

  &[data-size="medium"] {
    ${media.lessThan("medium")`
      width: 220px;
    `}
    ${media.lessThan("small")`
      width: 160px;
    `}
  }

  &[data-size="small"] {
    ${media.lessThan("medium")`
      width: 180px;
    `}
    ${media.lessThan("small")`
      width: 140px;
    `}
  }

  ${media.lessThan("medium")`
    margin-right: 0.5rem;
  `}

  ${media.lessThan("small")`
    margin-right: 0.25rem;
  `}

  /* Estilo para acessibilidade de idosos */
  .MuiTextField-root {
    .MuiInputBase-input {
      padding: ${(props: HeaderSearchContainerProps) => {
        switch (props.size) {
          case 'large': return '10px 16px'; /* Reduzido de 14px para 10px */
          case 'medium': return '8px 14px'; /* Reduzido de 10px para 8px */
          case 'small': return '6px 12px'; /* Reduzido de 8px para 6px */
          default: return '8px 14px';
        }
      }};

      &::placeholder {
        color: #666;
        opacity: 0.8;
        font-weight: 500;
      }
    }

    .MuiInputBase-root {
      border-radius: 50px; /* Bordas totalmente arredondadas - moderno */
      border: 2px solid #e0e0e0;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      transition: all 0.3s ease;

      /* Sombra sutil para destacar */
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

      &:hover {
        border-color: #bdbdbd;
        background: linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        transform: translateY(-1px);
      }

      &.Mui-focused {
        border-color: #013a7b;
        background: linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%);
        box-shadow: 0 4px 16px rgba(1, 58, 123, 0.25);
        transform: translateY(-1px);
      }

      .MuiOutlinedInput-notchedOutline {
        border: none; /* Remove borda padrão do MUI */
      }

      /* Estilo da lupa */
      .MuiInputAdornment-root {
        svg {
          color: #9e9e9e;
          transition: color 0.3s ease;
        }
      }

      &:hover .MuiInputAdornment-root svg {
        color: #757575;
      }

      &.Mui-focused .MuiInputAdornment-root svg {
        color: #013a7b; /* Azul escuro quando focado */
      }
    }
  }

  /* Botão de busca estilizado */
  .MuiButton-root {
    border-radius: 8px;
    text-transform: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
      transform: none;
    }
  }

  /* Para telas muito pequenas, ajustar botão */
  @media (max-width: 480px) {
    .MuiButton-root {
      min-width: 60px;
      padding: 8px 12px;
    }
  }
`;

export { HeaderSearchContainer };